import React, { useState } from 'react';
import { layout } from './Layout.module.css';
import MenuToggle from '../../components/Navigation/MenuToggle';
import Drawer from '../../components/Navigation/Drawer';
import { connect } from 'react-redux';
import { oneOfType, node, element, bool } from 'prop-types';

const Layout = ({ isAuthenticated, children }) => {
  const [menu, setMenu] = useState(false)

  return (
    <div className={layout}>
      <Drawer
        isOpen={menu}
        onClose={() => setMenu(false)}
        isAuthenticated={isAuthenticated}
      />

      <MenuToggle
        onToggle={() => setMenu(prevState => !prevState)}
        isOpen={menu}
      />

      <main>
        {children}
      </main>
    </div>
  )
}

const mapStateToProps = ({ auth: { token } }) => ({ isAuthenticated: !!token })

Layout.propTypes = {
  children: oneOfType([
    node, element
  ]),
  isAuthenticated: bool,
}

export default connect(mapStateToProps)(Layout)